import { watch } from 'vue';
import { useOnline } from '@vueuse/core';
import useModalHook from '@/hooks/useModal.js';

const useOfflineHook = () => {
  const isOnline = useOnline();
  const [isOfflineModalOpen, openOfflineModal, closeOfflineModal] = useModalHook();

  watch(
    isOnline,
    (curValue) => {
      if (!curValue) {
        openOfflineModal({ hideManually: true });
      } else {
        closeOfflineModal();
      }
    },
    { immediate: false },
  );

  return {
    isOfflineModalOpen,
  };
};

export default useOfflineHook;
